import React from "react";
import "./App.css";
import DetallePago from "./componets/DetallePago";
import Confirmacion from "./componets/Confirmacion";
import Common from "./componets/Common";

class App extends React.Component {
  state = {
    idComercio: `${Common.merchandId}`,
    viewDetalle: true,
    viewConfimar: false,
    viewPagoEfectivo: false,
    orden: "",
    mensaje: "",
    fecha: "",
    jwt: "",
  };
  handleConfirmar = (orden, mensaje, fecha, jwt) => {
    this.setState({
      viewConfimar: true,
      viewDetalle: false,
      viewPagoEfectivo: false,
      orden: orden,
      mensaje: mensaje,
      fecha: fecha,
      jwt: jwt,
      tarjeta: "",
      tipotarjeta: "",
    });
  };
  handleValidar = (orden, mensaje, fecha, jwt, tipotarjeta, tarjeta) => {
    this.setState({
      viewConfimar: true,
      viewDetalle: false,
      viewPagoEfectivo: false,
      orden: orden,
      mensaje: mensaje,
      fecha: fecha,
      jwt: jwt,
      tarjeta: tarjeta,
      tipotarjeta: tipotarjeta,
    });
  };
  handlePagoEfectivo = (orden, jwt, codigoAlumno) => {
    this.setState({
      viewConfimar: false,
      viewDetalle: false,
      viewPagoEfectivo: true,
      orden: orden,
      jwt: jwt,
      codigoAlumno: codigoAlumno,
    });
  };
  render() {
    return this.state.viewDetalle && !this.state.viewConfimar ? (
      <DetallePago
        idComercio={this.state.idComercio}
        handleConfirmar={this.handleConfirmar}
        handleValidar={this.handleValidar}
      ></DetallePago>
    ) : (
      <Confirmacion
        idComercio={this.state.idComercio}
        orden={this.state.orden}
        mensaje={this.state.mensaje}
        fecha={this.state.fecha}
        jwt={this.state.jwt}
        tarjeta={this.state.tarjeta}
        tipotarjeta={this.state.tipotarjeta}
      ></Confirmacion>
    );
  }
}

export default App;
